import { Injectable } from '@angular/core';
import { I18nService } from 'src/app/service/i18n.service';
@Injectable({
  providedIn: 'root'
})
export class GAdsPaidPixelService {

  private loadOk: boolean = false;
  currentLang: string;
  trackingCode: string = '';
  start: string;

  constructor(private i18nService: I18nService) {
    this.currentLang = sessionStorage.getItem("lang_pref")
  }

  load(instance: String) {

    // if (!this.loadOk) {

    if (instance == "start") {
      this.trackingCode = 'AW-997008455/mVIRCO34nIUDEMfItNsD'

    } else if (instance == "end") {
      this.trackingCode = 'AW-997008455/1V5VCPOgi3IQx8i02wM'

    }

    let content = "<!--Global site tag(gtag.js)- Google Ads:997008455--><script id=\"gads\" easync src=\"https://www.googletagmanager.com/gtag/js?id=AW-997008455\" type=\"text/plain\" class=\"optanon-category-C0004\"></script>"
    let content1 = "<script id=\"gtag_init\">window.dataLayer=window.dataLayer || [];function gtag(){ dataLayer.push(arguments); } gtag('js',new Date());gtag('config','AW-997008455');</script>"
    let content2 = "<!--Event snippet for CIBC | Mortgage Pre-Qual Tool Application Page conversion page--><script id=\"gads-conversion\">gtag('event','conversion',{'send_to':'" + this.trackingCode + "', 'transaction_id': ''});</script>"
    $("head").append(content);
    $("head").append(content1);
    $("head").append(content2);

  }
}


